export default __webpack_public_path__ + "static/media/SystemStudy.ef006955.png";